module.exports = __webpack_public_path__ + "static/img/Nelson-Asofa-Solomona.501685a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nelson-Asofa-Solomona.jpg
// module id = qDom
// module chunks = 0